// Auto-generado por @xone-web/staticweb a partir de LoginColl.xne.
// NO EDITAR: se regenera en cada build.
// Eventos lifecycle + custom + sintéticos (onclick/onchange por prop).

import type { XoneAPI } from "../xone-api";
import type { LoginCollFields } from "./LoginColl.types";
export async function loginOk(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    ui.openMenu("EntradaApp");
}
export async function loginFail(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    var err = self.getVariables("##LOGIN_ERRORDESCRIPTION##");
                    ui.msgBox("Login fail", "Error: [" + err + "]", 0);
}
export async function onback(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    appData.failWithMessage(-11888, "##EXITAPP##");
}
export async function load(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    try {
                    appData.executeSql("INSERT INTO ##PREF##Empresa (ID, CODIGO, NOMBRE) SELECT 1, '001', 'Empresa Principal' WHERE NOT EXISTS (SELECT 1 FROM ##PREF##Empresa WHERE ID = 1);");
                    appData.executeSql("INSERT INTO ##PREF##Usuarios (LOGIN, PWD, NOMBRE, IDEMPRESA) SELECT 'admin', 'admin', 'Administrador', 1 WHERE NOT EXISTS (SELECT 1 FROM ##PREF##Usuarios WHERE LOGIN = 'admin');");
                } catch (e) {
                    appData.writeConsoleString("Error init SQL: " + e.message);
                }
}
export async function BTN_ENTRAR_onclick(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    ui.showToast('Usuario: ' + self.MAP_USUARIO + ' | Pass: ' + self.MAP_PASSWORD);
}